import { CustomerRefFragment } from "@graphql";
import { CustomerProfileLocation } from "@navigation/locations/CustomerProfileLocation";
import { Navigation } from "@navigation";

export interface CanGoTopResponse {
  canGoTop: boolean;
  hideBackBtn: boolean;
  onTop: () => any;
  parentName: string;
}

export const badResultGoTop = {
  canGoTop: false,
  hideBackBtn: false,
  onTop: () => null,
  parentName: null
};

export const customerCanGoTop = (
  parents: CustomerRefFragment[],
  navigator: Navigation
): CanGoTopResponse => {
  if (parents.length === 0) {
    return badResultGoTop;
  }

  const { customerId } = navigator.location.params;

  const parent = parents[parents.length - 1];
  const cId = parent.Id;
  const parentName = parent.Name;
  if (cId === customerId) {
    return badResultGoTop;
  }

  const hideBackBtn = false;

  return {
    canGoTop: true,
    hideBackBtn,
    parentName,
    onTop: () => {
      navigator.navigate(new CustomerProfileLocation(cId));
    }
  };
};
